<template>
  <combobox-base
    @input="$emit('input', $event)"
    :query="query"
    :itemsGetter="itemsGetter"
    :value="value"
    label="Stav projektu"
  ></combobox-base>
</template>

<script>
import { useStatusesQuery } from "@/generated/backend";
import { useResult } from "@vue/apollo-composable";
import ComboboxBase from "./ComboboxBase.vue";
export default {
  components: { ComboboxBase },
  props: {
    value: { type: String },
  },
  setup() {
    return {
      query: (v) => useStatusesQuery(),
      itemsGetter: (result) => useResult(result, [], (r) => r.statuses),
    };
  },
};
</script>
<style></style>
